





















import { Component, Vue, Prop } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import Button from '@/apps/open/components/Button'

@Component({
  componentName: 'EditInceptMsgAdressForm',
  components: {
    Button
  }
})
export default class EditInceptMsgAdressForm extends Vue {
  @Prop({
    default: {}
  })
  value?: any

  @Prop()
  rules!: any

  @Prop()
  topicLength!: number

  @Prop()
  placeholder?: string

  @Prop()
  inputProps?: any

  @Prop()
  submit!: Function

  @Prop()
  onCancel!: Function

  @Prop()
  showMsgType!: Function

  $refs!: {
    form: ElForm
  }

  form = {
    input: this.value.open_msg_notify_url
  }

  onOk () {
    this.$refs.form.validate().then((valid: boolean) => {
      if (valid) {
        this.submit(this.form.input)
      }
    }).catch(e => {})
  }
}
